import { getApiPolicy, putApiPolicy } from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const documentPolicyQuery = createQuery({
  handler: getApiPolicy,
})

export const documentTermsQuery = createQuery({
  handler: getApiPolicy,
})

export const documentFacebookProfileDeletionGuideQuery = createQuery({
  handler: getApiPolicy,
})

export const documentOfferQuery = createQuery({
  handler: getApiPolicy,
})

export const documentCharterQuery = createQuery({
  handler: getApiPolicy,
})

export const updateDocument = createMutation({
  handler: putApiPolicy,
})
